const nodeList = [];
const Handler = Symbol('clickoutside Handler');
const BindTimer = Symbol('clickoutside BindTimer');

function createHandler(el, binding, vnode) {
  const methodName = binding.expression;
  const bindingFn = binding.value;

  let trigger;

  if (methodName && vnode.context[methodName]) {
    trigger = e => vnode.context[methodName](e);
  } else {
    trigger = e => bindingFn && bindingFn(e);
  }

  return clickEvent => {
    // 当 target 包含在 el 中，则退出
    if (!vnode || !vnode.context || !clickEvent.target || el.contains(clickEvent.target)) return;
    trigger(clickEvent);
  };
}

function clickEventListener(clientEvent) {
  nodeList.forEach(el => el[Handler](clientEvent));
}

/**
 * Vue directive
 * 当点击某个DOM 外部时触发
 */
export default {
  bind(el, binding, vnode) {
    /**
     * XXX:
     * 当 Vue 监听到 DOM 的一个 click 事件后
     * 会在下一个 micro task 执行重绘和本函数
     * 而事件冒泡到 document 顶层是在下个 macro task
     * 因此需要将对 document 的监听注册在 macro task 上
     * 避免 clickoutside 立即触发
     */
    el[BindTimer] = setTimeout(() => {
      if (nodeList.length === 0) {
        document.addEventListener('click', clickEventListener);
        document.addEventListener('mousedown', clickEventListener);
      }
      nodeList.push(el);
    }, 0);
    el[Handler] = createHandler(el, binding, vnode);
  },
  update(el, binding, vnode) {
    el[Handler] = createHandler(el, binding, vnode);
  },
  unbind(el) {
    nodeList.splice(nodeList.indexOf(el), 1);
    delete el[Handler];
    // 清除 bind 函数注册的 timeout，避免 bind 和 unbind 连续同步执行时最后依然注册事件监听
    clearTimeout(el[BindTimer]);
    if (nodeList.length === 0) {
      document.removeEventListener('click', clickEventListener);
      document.removeEventListener('mousedown', clickEventListener);
    }
  },
};
